import { render, staticRenderFns } from "./HaveHosting.vue?vue&type=template&id=3412ac30"
import script from "./HaveHosting.vue?vue&type=script&lang=js"
export * from "./HaveHosting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports